import * as Sentry from '@sentry/react';
import React from 'react';
import { createRoutesFromChildren, matchRoutes, useLocation, useNavigationType } from 'react-router-dom';

const dsn = import.meta.env.VITE_SENTRY_DSN;
const env = import.meta.env.VITE_APP_ENV || import.meta.env.MODE;

if (dsn) {
  Sentry.init({
    dsn,
    environment: env,
    enabled: !['localhost', '127.0.0.1'].includes(window.location.hostname),
    integrations: [
      Sentry.reactRouterV6BrowserTracingIntegration({
        useEffect: React.useEffect,
        useLocation,
        useNavigationType,
        createRoutesFromChildren,
        matchRoutes,
      }),
      Sentry.replayIntegration({
        maskAllText: true,
        blockAllMedia: true,
      }),
    ],

    // Performance Monitoring
    tracesSampleRate: env === 'production' ? 0.2 : 1.0,

    // Session Replay
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
  });

  // Set default tags
  Sentry.setTag('app_name', 'warehouse-package-scanning');
} else {
  console.warn('Sentry DSN not found. Sentry is not initialized.');
}
